var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"clearfix",attrs:{"dis-hover":"","padding":0}},[_c('Table',{staticClass:"data-table",attrs:{"size":_vm.size,"show-header":_vm.showHeader,"no-data-text":_vm.noDataText,"columns":_vm.filteredColumns,"data":_vm.submissions,"loading":_vm.loading},on:{"on-selection-change":_vm.onSelectionChange,"on-sort-change":_vm.onSort,"on-cell-click":_vm.onCellClick},scopedSlots:_vm._u([{key:"id",fn:function(ref){
var row = ref.row;
return [_c('router-link',{attrs:{"to":{
        name: _vm.contestId ? 'contest-submission-detail' : 'submission-detail',
        params: { submissionId: row.submissionId }
      }}},[_vm._v(_vm._s(row.submissionId))])]}},{key:"title",fn:function(ref){
      var row = ref.row;
return [_c('router-link',{attrs:{"to":{
        name: _vm.contestId ? 'contest-problem' : 'problem-detail',
        params: { problemCode: row.problemCode }
      }}},[_vm._v(_vm._s(row.problemTitle))])]}},{key:"judge-result",fn:function(ref){
      var row = ref.row;
return [_c('JudgeResult',{attrs:{"result":row.judgeResult,"total":row.checkpointNum,"current":row.$judgedNum}})]}},{key:"time",fn:function(ref){
      var row = ref.row;
return [_c('span',{staticClass:"time"},[_vm._v(_vm._s(row.usedTime || 0))])]}},{key:"mem",fn:function(ref){
      var row = ref.row;
return [_c('span',{staticClass:"mem"},[_vm._v(_vm._s(row.usedMemory || 0))])]}},{key:"submit-time",fn:function(ref){
      var row = ref.row;
return [_c('Tooltip',{attrs:{"content":_vm._f("timeformat")(row.gmtCreate,'yyyy-MM-DD HH:mm:ss'),"transfer":""}},[_c('span',[_vm._v(_vm._s(_vm._f("fromnow")(row.gmtCreate)))])])]}}])}),_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }